export class UpdateQuoteServiceMessage {
  price: number

  constructor(price: number) {
    this.price = price
  }
}
